import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { AccessibilityClickableDiv } from '@skillz/accessibility';
import { reportLmsAction } from "../../../utils/reportLmsAction";
import verbsTypes from "../../../enums/verbsTypes";

const Link = ({ link, objectName, children, ...props }) => {

    const handleExternalLinkClick = async () => {
        await reportLmsAction(verbsTypes.ENTER, link, null, objectName);
        window.open(link, '_blank');
    };

    if (link?.startsWith('http')) {
        return (
            <AccessibilityClickableDiv
                onClick={handleExternalLinkClick}
                {...props}>
                {children}
            </AccessibilityClickableDiv>
        );
    }

    return (
        <RouterLink to={link} {...props}>
            {children}
        </RouterLink>
    );
};

export default Link;
